import {SignInOut} from "./SignInOut";

const HeaderLut = {
  header_01: SignInOut,
}

export { HeaderLut };
